import { useState } from "react";
import { Button } from "@shared/ui/button";
import { Dialog, Field } from "@shared/ui/bits";
import { Input } from "@shared/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared/ui/select";
import { QUARTERS, clockField, combine, dateField, nextQuarter } from "../lib/times";

/**
 * «Другое…» в сроках напоминания — как окно «Установить пользовательское
 * напоминание» в Discord: дата и время шагом в четверть часа.
 */
export function ReminderDialog({
  onSave,
  onClose,
}: {
  onSave: (at: Date) => Promise<void> | void;
  onClose: () => void;
}) {
  const start = nextQuarter(new Date());
  const [date, setDate] = useState(dateField(start));
  const [clock, setClock] = useState(clockField(start));
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const at = combine(date, clock);

  async function save() {
    if (!at || at.getTime() <= Date.now()) {
      setProblem("Этот срок уже прошёл");
      return;
    }
    setBusy(true);
    setProblem(null);
    try {
      await onSave(at);
      onClose();
    } catch {
      setProblem("Не получилось поставить напоминание");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog
      title="Своё напоминание"
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" type="button" onClick={onClose}>
            Отмена
          </Button>
          <Button type="button" disabled={busy || !at} onClick={() => void save()}>
            Сохранить
          </Button>
        </>
      }
    >
      <div className="reminder-fields">
        <Field label="Дата">
          <Input
            type="date"
            value={date}
            min={dateField(new Date())}
            onChange={(event) => setDate(event.target.value)}
          />
        </Field>
        <Field label="Время" error={problem ?? undefined}>
          <Select value={clock} onValueChange={setClock}>
            <SelectTrigger aria-label="Время">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {QUARTERS.map((value) => (
                <SelectItem key={value} value={value}>
                  {value}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>
    </Dialog>
  );
}
